/**
 * @description 导出默认通用配置
 */
let staticUrl = '';

if (import.meta.env.VITE_ENV_CONFIG.includes('dev') || import.meta.env.VITE_ENV_CONFIG.includes('test')) {
    staticUrl = 'https://test-m2cdn.fastindexs.com';
} else if (import.meta.env.VITE_ENV_CONFIG.includes('pre')) {
    staticUrl = 'https://pre-m2cdn.fastindexs.com';
} else if (import.meta.env.VITE_ENV_CONFIG.includes('prod')) {
    staticUrl = 'https://m2cdn.fastindexs.com';
}
export const setting = {
    // 是否显示logo，不显示时设置false assets/images文件夹
    // logoImage: '/svg/ce-logo.svg',
    // logoImage: '/svg/ce-logo-all.svg',
    // WQ 这个变量不用了（满足不了多个环境的配置需求）
    logoImage: '/ce-logo.png',
    // logo文字
    // logoText: 'CE-DEMO-TEMPLATE',
    logoText: '',
    // 标题 （包括初次加载雪花屏的标题 页面的标题 浏览器的标题）
    title: '新门户',
    // public/index.html head-meta-description 网站描述
    description: '新门户',
    // 版权信息标识
    copyright: 'ce',
    // 是否显示页面底部自定义版权信息
    footerCopyright: true,
    // 加载时显示文字
    loadingText: '正在加载中...',
    // 消息框消失时间
    messageDuration: 3000,
    // 系统通用存储key的前缀
    publicKey: 'ce-center-',
    // 字典key标识
    dicKey: 'dictionary',
    // token存储位置localStorage sessionStorage 涉及所有accessInstance accessToken accessUserInfo等
    storage: 'localStorage',
    // 是否显示在页面高亮错误 需要开启plugin/error_log.jss
    // errorLog: ['development', 'production'],
    // 是否显示console 显示:true 关闭:false
    isConsole: import.meta.env.VITE_ENV_CONFIG.includes('dev') || import.meta.env.VITE_ENV_CONFIG.includes('test') ? true : false,
    // isConsole: true,
    // 打包配置 一定要配置绝对路径不然在动态路由加载js的时候会出现加载位置不是根目录
    assetsPublicPath: staticUrl + '/npmanager/', // 域名会发生变化，不能写死域名打包，需要使用相对。赵云波
    // assetsPublicPath: '//pre-m1.yun300.cn/npmanager/',
};
